var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasOffers)?_c('JobOffersTable',_vm._b({staticClass:"JobOffers__Table",attrs:{"openLinkInNewTab":_vm.openLinkInNewTab}},'JobOffersTable',{ offers: _vm.offers },false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }